import { render } from "./ViewStuffingComponent.vue?vue&type=template&id=4a8e3034"
import script from "./ViewStuffingComponent.vue?vue&type=script&lang=js"
export * from "./ViewStuffingComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__